import { makeAutoObservable } from "mobx";

import { Column } from "./Column";
import MealPlanFormStore from "./MealPlanFormStore";

export default class Columns {
  static MEAL_PATTERN_COLUMN_INDEX = 0;

  durationDays = 0;
  startDate = new Date();

  // Store already created DayColumn instances here so that there's only one
  // DayColumn instance lying around for each index.
  private instances: Map<number, Column> = new Map();
  private store: MealPlanFormStore;

  private get array() {
    const arr = [];
    for (let index = 0; index <= this.durationDays; index++) {
      arr.push(this.at(index));
    }
    return arr;
  }

  constructor(store: MealPlanFormStore) {
    makeAutoObservable(this);
    this.store = store;
    const mealPatternDay = new Column(
      store,
      Columns.MEAL_PATTERN_COLUMN_INDEX,
      "meal_pattern"
    );
    this.instances.set(mealPatternDay.index, mealPatternDay);
  }

  setDuration(durationDays: number, startDate = new Date()): void {
    this.durationDays = durationDays;
    this.startDate = startDate;
  }

  at(index: number): Column {
    if (!this.instances.has(index)) {
      this.instances.set(index, new Column(this.store, index));
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.instances.get(index)!;
  }

  map<T>(fn: (day: Column) => T): T[] {
    return this.array.map(fn);
  }

  flatMap<T>(fn: (day: Column) => T | T[]): T[] {
    return this.array.flatMap(fn);
  }

  previous(day: Column): Column {
    return this.at(Math.max(day.index - 1, 0));
  }

  next(day: Column): Column {
    return this.at(Math.min(day.index + 1, this.durationDays));
  }
}
